export default __webpack_public_path__ + "assets/images/2.9d8312.webp";